import React from 'react';
import { Group, Box } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';
import { Avatar } from '~/domains/design-system/Avatar';
import { Title } from '~/domains/design-system/Title';
import { CurrencyConvertor } from '~/components/utils/formatters';

import { getContestThumbnail } from '../../utils/getContestThumbnail';
import type { InviteContest } from '../../../entries/types/inviteContest';

import useStyles from '~/domains/common/components/AlertCard/alertCard.styles';

const AVATAR_SIZE = 48;

interface ContestInviteCardContestInfoProps {
  contest: InviteContest;
}

function ContestInviteCardContestInfo({ contest }: ContestInviteCardContestInfoProps) {
  const { classes } = useStyles();

  const avatarSrc = getContestThumbnail({
    contestThumbnailUrl: contest?.thumbnail_url,
    createdByAdmin: contest?.created_by_admin,
    avatarUrl: contest.owner?.avatarUrl,
  });

  return (
    <Group className={classes.contestSection} spacing="sm">
      <Avatar handle={contest.owner?.handle} size={AVATAR_SIZE} src={avatarSrc} />
      <Box className={classes.contestInfo}>
        <Title variant="headline-medium" className={classes.contestName}>
          {contest.name}
        </Title>
        {!contest.isEntertainmentOnly && (
          <Group className={classes.contestMeta}>
            <Text variant="body-medium" className={classes.metaItem}>
              <span className={classes.metaLabel}>Entry:</span>{' '}
              <span className={classes.metaValue}>
                {contest?.entryFee != null ? CurrencyConvertor(contest.entryFee / 100) : '-'}
              </span>
            </Text>
            <Text className={classes.metaDivider} variant="body-small">
              •
            </Text>
            <Text variant="body-medium" className={classes.metaItem}>
              <span className={classes.metaLabel}>Prizes:</span>{' '}
              <span className={classes.metaValue}>
                {contest?.prizePool != null ? CurrencyConvertor(contest.prizePool / 100) : '-'}
              </span>
            </Text>
          </Group>
        )}
      </Box>
    </Group>
  );
}

export default ContestInviteCardContestInfo;
